import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import { useTypedApiClient } from '@m3-tech/boss-api'
import { useCurrentUser } from '@m3-tech/boss-core'
import type { paths, Api_Employee_Get_Response } from '@m3-tech/boss5-api-types'
import { API_EMPLOYEE } from '@/constants/apiRoutes'
import { EMPLOYEE_QUERY_KEY } from '@/constants/queryKeys'

export function useEmployee(
    queryProps?: Omit<UseQueryOptions<Api_Employee_Get_Response, Error>, 'queryKey' | 'queryFn'>,
) {
    const client = useTypedApiClient<paths>()
    const user = useCurrentUser()
    const objectId = user?.id

    return useQuery({
        ...queryProps,
        queryKey: [...EMPLOYEE_QUERY_KEY, objectId],
        queryFn: async () => {
            const { data, error } = await client.GET(API_EMPLOYEE, {
                params: { query: { objectId } },
            })
            if (error) throw error
            return data
        },
        enabled: (queryProps?.enabled ?? true) && objectId != null,
    })
}
